import React, { useEffect, useState } from 'react';
import Formulario from './PresupuestoForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

function Presupuesto(props) {
    const { loader, modulo, datos,
        listarProyectos, detalleProducto, buscarCliente,
        detalleOrden, registroPresupuesto, agregarLinea, detalleOrd,
        eliminarLinea, listarLineas, agregarLineaNueva, cambioD,
        modificarPresupuesto, eliminarLineaGasto, clienteProyecto, tipoProyecto
    } = props;        
        
    useEffect(() => {
        const { match, leer, getModulo,
            limpiarPresupuesto } = props;
        const id = match.params.id;
        if (id) {
            setCrear(false);
            leer(id);
        }
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        getModulo(periodo[5], periodo[4]);
        //parametrosEmpresa();
        limpiarPresupuesto();
    }, [])

    const [crear, setCrear] = useState(true);

    const editar = window.location.href.includes('editar');
    let titulo = 'Crear presupuesto';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver presupuesto';
    }

    return (
        <LoadMask loading={loader} dark>
            <Formulario
                registroPresupuesto = {registroPresupuesto}
                modificarPresupuesto = {modificarPresupuesto}
                datos = {datos}
                crear = {crear}
                titulo = {titulo}
                editar = {editar}
                modulo = {modulo}
                bloqueo = {disabled}
                listarProyectos = {listarProyectos}
                detalleProducto = {detalleProducto}
                detalleOrden = {detalleOrden}
                agregarLinea = {agregarLinea}
                detalleOrd = {detalleOrd}
                eliminarLinea = {eliminarLinea}
                listarLineas = {listarLineas}
                agregarLineaNueva = {agregarLineaNueva}
                eliminarLineaGasto = {eliminarLineaGasto}
                buscarCliente = {buscarCliente}
                clienteProyecto = {clienteProyecto}
                cambioD = {cambioD}
                tipoProyecto = {tipoProyecto}
            />
        </LoadMask>
    );
}

export default Presupuesto;